import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfterSection() {
  const before = ['No sabés qué cocinar.', 'Buscás recetas durante horas.', 'Terminás comiendo cualquier cosa.', 'Dietas difíciles y restrictivas.'];
  const after = ['Abrís el ebook.', 'Elegís una receta.', 'Preparás la comida en minutos.', 'Comés mejor todos los días.'];
  return <section className="py-24 bg-white" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight" data-id="element-41">
            El cambio que necesitás
          </h2>
          <p className="text-lg text-ink-light" data-id="element-42">
            Pasá de la frustración a la tranquilidad con un sistema que
            realmente funciona.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-43">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream p-8 md:p-12 rounded-[2.5rem] border border-ink/5 relative overflow-hidden" data-id="element-44">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-bl-full" data-id="element-45"></div>
            <h3 className="text-2xl font-bold text-ink mb-8 flex items-center gap-3" data-id="element-46">
              <span className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-sm" data-id="element-47">
                <XCircle className="w-5 h-5" data-id="element-48" />
              </span>
              ANTES
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-49">
              {before.map((item, i) => <li key={i} className="flex items-start gap-4 text-ink-light text-lg" data-id="element-50">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-51" />
                  <span data-id="element-52">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-combo-green text-white p-8 md:p-12 rounded-[2.5rem] shadow-premium relative overflow-hidden" data-id="element-53">
            <div className="absolute top-0 right-0 w-48 h-48 bg-white/10 rounded-bl-full" data-id="element-54"></div>
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-55">
              <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-sm" data-id="element-56">
                <CheckCircle2 className="w-5 h-5" data-id="element-57" />
              </span>
              DESPUÉS
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-58">
              {after.map((item, i) => <li key={i} className="flex items-start gap-4 text-white/90 text-lg" data-id="element-59">
                  <CheckCircle2 className="w-6 h-6 text-white flex-shrink-0 mt-0.5" data-id="element-60" />
                  <span data-id="element-61">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}